import * as _ from 'lodash';
import { PortfolioRepo } from '@services/portfolio.repo'
import { portfolioSelectorService } from '../portfolioSelector';

class OverviewController implements angular.IOnInit {

  /** @ngInject */
  constructor(private portfolioRepo: PortfolioRepo, private portfolioSelectorService: portfolioSelectorService) {
  }


  $onInit() {
  }

  public getGeographyData() {
    return this.portfolioRepo.getPortfolioAggregatesByGeography(this.portfolioSelectorService.getSelectedCurrency(), this.portfolioSelectorService.getSelectedPortfolios() );
  }

  public getSectorData() {
    return this.portfolioRepo.getPortfolioAggregatesBySector(this.portfolioSelectorService.getSelectedCurrency(),this.portfolioSelectorService.getSelectedPortfolios());
  }

}


export const overview: angular.IComponentOptions = {
  template: require('./overview.html'),
  controller: OverviewController
}



// WEBPACK FOOTER //
// ./src/app/portfolio/geographyAndSector/overview.ts